import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ebay = defineConnector({
  identifier: "ebay",
  name: "eBay",
  tagLine: "Online marketplace",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.ebay\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create an eBay app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [eBay Developer Program](https://developer.ebay.com/my/keys) and sign in. Click **Create a keyset** for the Production environment to get your OAuth credentials.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/ebay/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your eBay account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your eBay account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://auth.ebay.com/oauth2/authorize",
    tokenEndpoint: () => "https://api.ebay.com/identity/v1/oauth2/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.ebay.com/commerce/identity/v1/user/",
  },
});
